import React from 'react';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const HeroSection = () => {
  const handleLaunch = (e) => {
    e.preventDefault();
    toast('Coming soon', {
      description: 'The full app is launching soon. Explore the live demo in the Solution section.',
    });
    document.getElementById('solution')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section" data-testid="hero-section">
      {/* Background: faint grid + single radial green wash behind the mock */}
      <div className="hero-grid-bg">
        <div className="grid-lines"></div>
        <div className="hero-glow"></div>
      </div>

      {/* Oversized watermark mark */}
      <img src="/brand/mark-green.png" alt="" aria-hidden="true" className="hero-watermark" />

      <div className="hero-inner">
        {/* LEFT: Copy */}
        <div className="hero-copy">
          <div className="hero-badge animate-fade-in">
            <span className="badge-dot"></span>
            <span>Privacy-First AI Access</span>
          </div>

          <h1 className="hero-title animate-fade-in-up">
            The Secure Layer
            <br />
            <span className="gradient-text">to Access All AI</span>
          </h1>

          <p className="hero-subtitle animate-fade-in-up delay-1">
            One layer. One token. Every AI platform. Zero exposure.
          </p>

          <div className="hero-buttons animate-fade-in-up delay-2">
            <a href="#" onClick={handleLaunch} className="btn-solid" data-testid="hero-launch-btn">
              Launch App
              <ArrowRight size={16} />
            </a>
            <a href="#solution" onClick={(e) => { e.preventDefault(); document.getElementById('solution')?.scrollIntoView({ behavior: 'smooth' }); }} className="btn-ghost" data-testid="hero-docs-btn">
              Try the Demo
            </a>
          </div>

          {/* Trust row */}
          <div className="hero-trust animate-fade-in-up delay-3">
            <span className="trust-label">Works with</span>
            <div className="trust-logos">
              <img src="/brand/ai/openai.png" alt="OpenAI" />
              <img src="/brand/ai/anthropic.png" alt="Anthropic" />
              <img src="/brand/ai/gemini.png" alt="Gemini" />
              <img src="/brand/ai/meta.png" alt="Meta Llama" />
            </div>
          </div>
        </div>

        {/* RIGHT: Product mock, perspective-tilted */}
        <div className="hero-mock animate-fade-in-up delay-2">
          <div className="preview-window">
            <div className="preview-header">
              <div className="preview-dots">
                <span className="dot red"></span>
                <span className="dot yellow"></span>
                <span className="dot green"></span>
              </div>
              <span className="preview-title">zyber-secure</span>
            </div>
            <div className="preview-content">
              <div className="preview-sidebar">
                <div className="sidebar-item active">Dashboard</div>
                <div className="sidebar-item">AI Services</div>
                <div className="sidebar-item">Wallet</div>
                <div className="sidebar-item">Settings</div>
              </div>
              <div className="preview-main">
                <div className="main-header">
                  <span className="main-title">Connected Services</span>
                  <span className="main-badge">3 Active</span>
                </div>
                <div className="service-list">
                  <div className="service-item">
                    <div className="service-icon gpt"><img src="/brand/ai/openai.png" alt="OpenAI" /></div>
                    <div className="service-info">
                      <span className="service-name">ChatGPT Plus</span>
                      <span className="service-status">Active</span>
                    </div>
                    <span className="service-usage">2.4k tokens</span>
                  </div>
                  <div className="service-item">
                    <div className="service-icon claude"><img src="/brand/ai/anthropic.png" alt="Claude" /></div>
                    <div className="service-info">
                      <span className="service-name">Claude Pro</span>
                      <span className="service-status">Active</span>
                    </div>
                    <span className="service-usage">1.8k tokens</span>
                  </div>
                  <div className="service-item">
                    <div className="service-icon gemini"><img src="/brand/ai/gemini.png" alt="Gemini" /></div>
                    <div className="service-info">
                      <span className="service-name">Gemini Advanced</span>
                      <span className="service-status">Active</span>
                    </div>
                    <span className="service-usage">3.1k tokens</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
